export default "__VITE_ASSET__SUMZ4jiL__"